import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription} from "../../../user/user-subscription";
import {TypeUtils} from "../../../shared/utils/type-utils";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";

@Component({
    selector: 'db-trial-subscription-plan',
    templateUrl: './trial-subscription-plan.component.html',
    styleUrl: './trial-subscription-plan.component.scss',
    standalone: false
})
export class TrialSubscriptionPlanComponent implements OnInit {
  daysUntilNext: number;
  freeDays: number;
  percentageLeft: number;
  usedAiCredits$ = this._store.select(fromStore.selectUsedAiCredits);
  vibeLimitationData: any;


  @Input('userSubscription') set currentSubscription(sub: UserSubscription) {
    this.userSubscription = sub;
  }

  userSubscription!: UserSubscription;
  @Input() userLocalStorage!: any;
  @Output() onUpgradeClick: EventEmitter<void> = new EventEmitter();
  constructor(private _store: Store<fromStore.DbStoreState>) {
  }

  ngOnInit(): void {
    this._store.dispatch(new fromStore.LoadUsedAiCredits());
    this._calculateBillingProgress(
      this.userSubscription.nextBillingDate?.toString() ||
      this.userSubscription.expireDate?.toString() || this.userSubscription?.hostingTrialExpireDate?.toString(),
    );
  }

  private _calculateBillingProgress(nextBillingDate: string) {
    if (!nextBillingDate) return;

    const currentDate = new Date();
    const nextDate = new Date(nextBillingDate);

    this.daysUntilNext = Math.ceil((nextDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

    this.freeDays = Math.ceil(
      (nextDate.getTime() - (
          TypeUtils.isDefined(this.userLocalStorage?.['extend_agreement'])
            ? currentDate.getTime()
            : this.userSubscription.agreementDate?.getTime())
      ) / (1000 * 60 * 60 * 24)
    );
    this.vibeLimitationData = {
      planLimit: this.userSubscription?.editTotal,
      alreadyUsed: this.userSubscription?.editUsed,
    };

    this.percentageLeft = Math.max(0, Math.min(100, ((this.daysUntilNext / this.freeDays) * 100)));
  }

}
